import { DEGRADATIONS_SOURCE_ID, IMAGES_SOURCE_ID, ROADS_SOURCE_ID, WIDTHS_SOURCE_ID } from '../core/domain/map';

export const SOURCES = {
    [IMAGES_SOURCE_ID]: {
        tilesPath: `/map/images/{z}/{x}/{y}.mvt`,
        minZoom: 15,
        maxZoom: 15,
    },
    [ROADS_SOURCE_ID]: {
        tilesPath: `/map/roads/{z}/{x}/{y}.mvt`,
        minZoom: 0,
        maxZoom: 15,
    },
    [WIDTHS_SOURCE_ID]: {
        tilesPath: `/map/widths/{z}/{x}/{y}.mvt`,
        minZoom: 18,
        maxZoom: 18,
    },
    [DEGRADATIONS_SOURCE_ID]: {
        tilesPath: `/map/degradations/{z}/{x}/{y}.mvt`,
        minZoom: 18,
        maxZoom: 18,
    },
};
